/** @typedef {import('../index.js').BaseDocData} BaseDocData */
import * as Yup from 'yup';
import YupFirestoreTimestamp from '../yupFirestoreTimestamp.js';

/**
 * Per-day lot code counter, stored in `lotCounters/{YYYYMMDD}` (the doc ID
 * is the date key from `lotDateKey`). `count` is the last bag number handed
 * out that day, incremented in the same transaction that creates a lot.
 */
export const lotCounterSchema = Yup.object().shape({
  count: Yup.number().required('Count is required'),
  updatedAt: YupFirestoreTimestamp.nullable().default(null),
});

/**
 * @typedef {Yup.InferType<typeof lotCounterSchema>} LotCounterSchema
 * @typedef {BaseDocData & LotCounterSchema} LotCounterDocData
 */

export default class LotCounter {
  constructor({ id, count, updatedAt }) {
    const validatedData = lotCounterSchema.validateSync({ count, updatedAt });

    this.id = id || null;
    this.count = validatedData.count;
    this.updatedAt = validatedData.updatedAt ?? null;
  }

  toFirestore({ serverTimestamp }) {
    return {
      count: this.count,
      updatedAt: serverTimestamp(),
    };
  }

  static fromFirestore(docData) {
    return new LotCounter(docData);
  }
}
